import { Helmet } from 'react-helmet';
import React from 'react';

export const Empty = ({ message }: { message?: string }) => {
    const displayMessage = message ? message : 'Keine Einträge gefunden';

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
            </Helmet>
            <p className="font-sans text-secondary my-16">{displayMessage}</p>
        </>
    );
};
